import { recipe } from "@vanilla-extract/recipes";
import { keyframes } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "../../theme/css/theme.css";
import { transition } from "../../utils/transition";

const infiniteAnimation = keyframes({
  "0%": {
    marginLeft: "-40%",
  },
  "100%": {
    marginLeft: "100%",
  },
});

export const trackStyle = recipe({
  base: {
    width: "100%",
    borderRadius: "999px",
    overflow: "hidden",
    position: "relative",
    transition: transition("opacity"),
  },
  variants: {
    variant: {
      custom: {},
      default: {},
      infinite: {},
    },
    align: {
      top: {
        top: 0,
      },
      bottom: {
        bottom: 0,
      },
    },
    position: {
      default: {
        maxWidth: rem(360),
        backgroundColor: "var(--background-color)",
        height: rem(6),
      },
      absolute: {
        position: "absolute",
        left: 0,
        height: rem(3),
        zIndex: 2,
      },
    },
    color: {
      default: {
        vars: {
          "--background-color": theme.colors.panel,
        },
      },
      defaultAlternative: {
        ":before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: theme.colors.onBackground,
          opacity: 0.05,
        },
        vars: {
          "--background-color": theme.colors.panel,
        },
      },
      success: {
        vars: {
          "--background-color": theme.colors.panel,
        },
      },
      error: {
        vars: {
          "--background-color": theme.colors.panel,
        },
      },
      warning: {
        vars: {
          "--background-color": theme.colors.panel,
        },
      },
      onBackground: {
        vars: {
          "--background-color": theme.colors.panel,
        },
      },
      background: {
        opacity: 0.5,
        vars: {
          "--background-color": theme.colors.background,
        },
      },
      currentColor: {
        vars: {
          "--background-color": "transparent",
        },
      },
      backgroundAlpha: {
        backgroundColor: "transparent",
      },
      gradient: {
        vars: {
          "--background-color": "rgba(0, 0, 0, 0.2)",
        },
      },
    },
  },
  defaultVariants: {
    variant: "default",
    color: "default",
  },
});

export const fillStyle = recipe({
  base: {
    height: "100%",
    borderRadius: "999px",
  },
  variants: {
    variant: {
      custom: {},
      default: {
        transition: transition({
          property: "width",
          duration: theme.transition.duration.l,
        }),
      },
      infinite: {
        width: "40%",
        position: "relative",
        overflow: "hidden",
        transition: transition("width", "left"),
        animation: `${infiniteAnimation} 1.5s ease-in-out infinite`,
      },
    },
    position: {
      default: {},
      absolute: {},
    },
    color: {
      default: {
        backgroundColor: theme.colors.primary,
      },
      defaultAlternative: {
        backgroundColor: theme.colors.primary,
      },
      onBackground: {
        backgroundColor: theme.colors.onBackground,
      },
      success: {
        backgroundColor: theme.colors.success,
      },
      error: {
        backgroundColor: theme.colors.error,
      },
      warning: {
        backgroundColor: theme.colors.warning,
      },
      background: {
        backgroundColor: theme.colors.background,
      },
      backgroundAlpha: {
        backgroundColor: theme.colors.secondary,
        opacity: 0.75,
      },
      currentColor: {
        backgroundColor: "currentColor",
        opacity: 0.75,
      },
      gradient: {
        background: `linear-gradient(105deg, ${theme.colors.gradientA} -10%, ${theme.colors.gradientB} 25%, ${theme.colors.gradientC} 90%)`,
      },
    },
  },
  defaultVariants: {
    variant: "default",
    position: "default",
    color: "default",
  },
});
